import React, { useCallback } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button, Empty, Popconfirm, Space, Tag, Tooltip } from 'antd'
import {
  CloseOutlined,
  TeamOutlined,
} from '@ant-design/icons'
import { yellowPrimary } from '../../color'
import { AvatarHasName } from '../Common/Avatar'
import SelectGroupBoxTruc from './SelectGroupBoxTruc'

const SelectGroupPopupTruc = props => {
  const {
    isVisibleSelectGroupPopupTruc,
    handleSubmitSelectGroupTruc,
    handleCancelSelectGroupTruc,
    userTrucStore,
  } = props

  const { selectGroupDataTruc } = userTrucStore

  const onCancelSelectGroup = () => {
    handleCancelSelectGroupTruc()
  }

  const handleRemoveSelect = useCallback(
    group => {
      userTrucStore.setSelectGroupDataTruc(
        selectGroupDataTruc.filter(el => el.id !== group.id)
      )
    },
    [selectGroupDataTruc]
  )

  return (
    <Modal
      className="custom-modal-wrapper assign-member-modal"
      maskClosable={false}
      okText={'Đồng ý'}
      cancelText={'Hủy bỏ'}
      width={800}
      footer={null}
      style={{ top: 20 }}
      title={
        <div className="assign-member-modal-title-container">
          <div>
            <span style={{ fontSize: 16, fontWeight: 500 }}>Bảng chọn nhóm</span>
          </div>
          <div className="group-btn-action">
            <Popconfirm
              placement="bottom"
              title={'Bạn có chắc chắn muốn xóa hết người được chọn không ?'}
              onConfirm={onCancelSelectGroup}
              okText="Đồng ý"
              cancelText="Không" zIndex={1600}>
              <Button
                danger
                style={{ borderRadius: 8 }}>
                Hủy chọn
              </Button>
            </Popconfirm>
            <Button type={'primary'} style={{ borderRadius: 8 }} onClick={handleSubmitSelectGroupTruc}>
              Đồng ý
            </Button>
            <Tooltip title={'Đóng'}>
              <CloseOutlined style={{ fontSize: 20, cursor: 'pointer' }} onClick={handleSubmitSelectGroupTruc} />
            </Tooltip>
          </div>
        </div>
      }
      closable={false}
      forceRender={true}
      visible={isVisibleSelectGroupPopupTruc}>
      <div className="assign-member-modal-left-box">
        <div className="assign-member-modal-left-content" style={{ position: 'relative' }}>
          <SelectGroupBoxTruc />
        </div>
      </div>
      <div className="assign-member-modal-right-box">
        <div
          style={{
            marginBottom: 16,
            fontWeight: 500,
            color: '#333',
          }}>
          Danh sách đã chọn:
        </div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 8,
          }}>
          {selectGroupDataTruc.length > 0 &&
            selectGroupDataTruc.map(el => {
                  return (
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClose={() => handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.name}
                        icon={<TeamOutlined />}
                      />
                    </Tag>
                  )
                })}
        </div>
      </div>
    </Modal>
  )
}

SelectGroupPopupTruc.propTypes = {}

export default inject('userTrucStore')(observer(SelectGroupPopupTruc))
